import { CheckCircle, Shield, Zap, Users, Globe, Award } from "lucide-react";

export default function FeaturesSection() {
  const features = [
    {
      icon: Shield,
      title: "Secure & Verified",
      description:
        "All campaigns are verified and secure. Your social accounts and rewards are protected with industry-standard security.",
    },
    {
      icon: Zap,
      title: "Instant Verification",
      description:
        "Complete tasks and get verified instantly. Our automated system checks your participation in real-time.",
    },
    {
      icon: Users,
      title: "Community Driven",
      description:
        "Join a thriving community of BINGOLD enthusiasts and earn rewards through social engagement.",
    },
    {
      icon: Globe,
      title: "Global Access",
      description:
        "Participate from anywhere in the world. No geographical restrictions on earning BINGOLD tokens.",
    },
    {
      icon: Award,
      title: "Fair Distribution",
      description:
        "Transparent and fair reward distribution based on your participation and completion of campaign tasks.",
    },
    {
      icon: CheckCircle,
      title: "Easy to Use",
      description:
        "Simple and intuitive interface makes it easy for anyone to participate and claim rewards.",
    },
  ];

  const steps = [
    {
      step: "01",
      title: "Connect Wallet",
      description:
        "Connect your Web3 wallet to get started with BINGOLD campaigns.",
    },
    {
      step: "02",
      title: "Choose Campaign",
      description:
        "Browse active campaigns and select the ones you want to participate in.",
    },
    {
      step: "03",
      title: "Complete Tasks",
      description:
        "Follow, like, share, and engage on social media platforms as required.",
    },
    {
      step: "04",
      title: "Claim Rewards",
      description:
        "Once verified, claim your BINGOLD tokens directly to your wallet.",
    },
  ];

  return (
    <section id="features" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 md:px-6">
        {/* Features Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Why Choose{" "}
            <span className="text-bingold-gradient">BINGOLD Airdrop</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
            The most trusted and efficient platform for earning BINGOLD tokens
            through social media campaigns.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-gray-900/50 border border-yellow-500/20 rounded-2xl p-6 hover:border-yellow-500/40 transition-all duration-300 group"
              >
                <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-6 h-6 text-black" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* How It Works Section */}
        {/* <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            How It <span className="text-bingold-gradient">Works</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
            Get started in just 4 simple steps and begin earning BINGOLD tokens
            today.
          </p>
        </div> */}

        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-1/2 w-full h-0.5 bg-gradient-to-r from-yellow-400/50 to-transparent transform -translate-y-1/2 z-0"></div>
              )}

              <div className="relative z-10 w-24 h-24 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-black">
                  {step.step}
                </span>
              </div>

              <h3 className="text-xl font-semibold text-white mb-3">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div> */}

        {/* <div className="bg-gradient-to-r from-[#181300] to-[#160F00] border border-yellow-500/10 rounded-2xl py-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="md:text-4xl text-xl text-white mb-2">4.5 M</div>
              <div className="text-gray-400">Token Symbol</div>
            </div>

            <div>
              <div className="md:text-4xl text-xl text-white mb-2">65K+</div>
              <div className="text-gray-400">Blockchain</div>
            </div>

            <div>
              <div className="md:text-4xl text-xl text-white mb-2">6</div>
              <div className="text-gray-400">Total Supply</div>
            </div>

            <div>
              <div className="md:text-4xl text-xl text-white mb-2">95%</div>
              <div className="text-gray-400">Total Supply</div>
            </div>
          </div>
        </div> */}
      </div>

    </section>
  );
}
